<template>
    <div>
        <div v-if="services.length > 0" class="grid grid-cols-1 lg:grid-cols-2 col-gap-6 row-gap-8">
            <template v-for="(service, index) in services">
                <service-card :key="index" :service="service" />
            </template>
        </div>
        <div v-else class="text-gray-600 font-normal text-center font-hairline">
            No service found.
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            services: []
        };
    },

    mounted() {
        this.fetchServices();
    },

    methods: {
        fetchServices() {
            axios.get('/api/services').then(response => {
                this.services = response.data.data;
            });
        }
    }
};
</script>
